<template>
	<h4 class="h4">1. Встановити Gotify</h4>
	<p class="paragraph-indent">
		Втановіть додаток на мобільний телефон <!--<a href="https://play.google.com/store/apps/details?id=com.github.gotify">Google Play</a> або -->
		<a :href="DOWNLOAD_GOTIFY_URL" download="gotify-for-gasinvest.apk">apk файлом</a> (<i>надайте дозвіл на встановлення з невідомих джерел</i>).
	</p>

	<h4 class="h4">2. Підключитись до сервера</h4>
	<div class="row row-cols-1 row-cols-md-2">
		<div class="col col-xl-6 col-md-7">
			<p class="paragraph-indent">
				Після встановлення додатка необхідно підключитись до сервера сповіщень вашої організації 
				<i>(цю дію необхідно робити тільки один раз після встановлення додатка)</i>.
			</p>
			<p class="paragraph-indent">
				Відкрийте щойно встановлений додаток на мобільному телефоні і почніть налаштування.
			</p>
			<p class="paragraph-indent">
				Введіть адресу сервера http://{{SERVER_HOST_NAME}}/gotify, якщо вона вже не введена 
				автоматично і натисніть "Перевірити URL". Буде виконана перевірка зв'зку з сервером, 
				тому прослідкуйте щоб у вас був ввімкнений інтернет.
			</p>
		</div>
		<div class="col col-xl-3 col-md-5">
			<img :src=" `${GOTIFY_ICONS_URL}/man-1.png`" class="rounded float-center">
		</div>
	</div>
	<div class="row row-cols-1 row-cols-md-2">
		<div class="col col-xl-6 col-md-7">
			<p class="paragraph-indent">
				Погодьтесь з попередженням натиснувши "Я&nbsp;Розумію".
			</p>
			<p class="paragraph-indent">
				<i>Дане попередження не буде показано якщо ваш сервер використовує протокол https.</i>
			</p>
		</div>
		<div class="col col-xl-3 col-md-5">
			<img :src=" `${GOTIFY_ICONS_URL}/man-2.png`" class="rounded float-center">
		</div>
	</div>
	<div class="row row-cols-1 row-cols-md-2">
		<div class="col col-xl-6 col-md-7">
			<p class="paragraph-indent">
				Далі введіть ваш логін та пароль точно такі самі як в системі і натисніть "Увійти".
			</p>
			<p class="paragraph-indent">
				Буде виконано перевірку ваших даних.
			</p>
		</div>
		<div class="col col-xl-3 col-md-5">
			<img :src=" `${GOTIFY_ICONS_URL}/man-3.png`" class="rounded float-center">
		</div>
	</div>
	<div class="row row-cols-1 row-cols-md-2 mb-2">
		<div class="col col-xl-6 col-md-7">
			<p class="paragraph-indent">
				Далі введіть довільне ім'я вашого пристрою <i>(стане у нагоді якщо пристроїв більше одного)</i>, 
				або залиште ім'я по замовчуванню.
			</p>
			<p class="paragraph-indent">
				Натисніть "Створити" і ви закінчили підключення до сервера.
			</p>
		</div>
		<div class="col col-xl-3 col-md-5">
			<img :src=" `${GOTIFY_ICONS_URL}/man-4.png`" class="rounded float-center">
		</div>
	</div>

	<h4 class="h4">3. Протестувати підключення до сервера</h4>
	<div class="row row-cols-1 row-cols-md-2 mb-2">
		<div class="col col-xl-6 col-md-7">
			<p class="paragraph-indent">
				Щоб переконатись в правильності налаштувань або наявності зв'язку ви можете відправити собі 
				сповіщення з будь'яким повідомленням. Введіть довільний текст і натисніть "Надіслати". 
				Якщо налаштування вірні, то повідомлення одразу з'явиться в додатку.
			</p>
			<div class="row row-cols-1 mb-2">
				<div class="col py-1">
					<input
						v-model="testMessage"
						style="min-width: 25em;"
						placeholder="Введіть коротке повідомлення"
					/>
				</div>
				<div class="col py-1">
					<button
						class="btn btn-primary btn-sm"
						@click="sendTestMessage"
					>
						Надіслати
					</button>
				</div>
				<div class="col py-1">
					{{ testResponse }}&nbsp;
				</div>
			</div>
		</div>

		<div class="col col-xl-3 col-md-5">
			<img :src=" `${GOTIFY_ICONS_URL}/man-5.png`" class="rounded float-center">
		</div>
	</div>

	<h4 class="h4">4. Проблеми та їх вирішення</h4>
	<b>Не приходить тестове сповіщення</b><br>
	<p class="paragraph-indent">
		Переконайтесь що додаток на мобільному пристрої встановлено згідно інструкції, 
		є підключення до інтернет. Також перевірте чи не закрівається додаток системою 
		через оптимізацію споживання аккумулятора або режим "Не турбувати".
	</p>
</template>




<script>
import { GOTIFY_ICONS_URL, DOWNLOAD_GOTIFY_URL } from '@/app.conf'
import { useAccontStore } from '@/stores/AccountStore'
import { sendToGotify } from '@/api/api.js'


export default {
	setup() {
		const accountStore = useAccontStore()

		return {
			GOTIFY_ICONS_URL,
			DOWNLOAD_GOTIFY_URL,
			accountStore,
		}
	},

	data() {
		return {
			testMessage: "Тестове сповіщення",
			testResponse: "",
		}
	},

	methods: {
		sendTestMessage() {
			//console.log("message: ", this.testMessage, this.accountStore.userLogin, tokens[this.accountStore.userLogin])

			this.testResponse = ''

			if (this.testMessage.length == 0) {
				this.testMessage = "Тестове сповіщення"
			}

			//sendToGotify(this.testMessage, tokens[this.accountStore.userLogin])
			sendToGotify(
				this.testMessage,
				this.accountStore.account[this.accountStore.schema.gotify.self][this.accountStore.schema.gotify.testToken]
			)
			.then((response) => {
				if (response.ok) {
					this.testResponse = 'Сповіщення успішно відправлене'
				} else {
					console.error(response.statusText)
					this.testResponse = `Сталась помилка: ${response.statusText}`
				}
			})
			.catch((err) => {
				console.error(err.response ? err.response.data : err)
				this.testResponse = `Сталась помилка: ${err.response ? err.response.data : err}`
			})
		},
	},

	computed: {
	},
}
</script>